/** @flow */
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import IncreaseDecreasePercent from 'common/components/IncreaseDecreasePercent';
import { Numeric } from 'common/components/Number';
import { calculateMetricVariation, type ComparedMetric } from '../../domain/DashboardData';

const HeaderElement = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 18px;
  margin-bottom: ${({ theme }) => theme.metrics.margin}px; 
  margin-top: ${({ theme }) => theme.metrics.smallMargin}px; 
  align-items: start;
`;

const WeekendMetricContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

type Props = {
  day: string;
  metric: ComparedMetric;
  theme: any;
  t: any;
};

function DayMetricPrintingElement({ day, metric, t, theme }: Props) {
  return (
    <WeekendMetricContainer>
      <HeaderElement>
        { day }
      </HeaderElement>
      <HeaderElement>
        <Numeric
          value={metric.current}
          roundAt={0}
          style={{
            fontSize: theme.fonts.style.secondary.midSmall,
            color: theme.colors.primary,
            marginRight: theme.metrics.tinyMargin,
          }}
        />
        <IncreaseDecreasePercent
          percent={calculateMetricVariation(metric)}
          iconSize={{ width: 20, height: 20 }}
          textStyle={{ fontSize: '13px' }}
        />
      </HeaderElement>
    </WeekendMetricContainer>
  );
}

export default withTheme(DayMetricPrintingElement);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/components/DayMetricPrintingElement.js